import type { BuyerOption } from '@/features/shop-insurance';

const MARITAL_STATUS_MAPPING: Record<string, string> = {
  'Never married': 'Single',
  'Married': 'Married',
  'Married, spouse absent': 'Married',
  'Partnered': 'Married',
  'Separated': 'Single',
  'Divorced': 'Single',
  'Widowed': 'Single',
  "I don't know / prefer not to answer": 'Single',
};

export const mapMaritalStatusToTraditionalLTC = (maritalStatus?: string): string => {
  if (!maritalStatus) return 'Single';
  return MARITAL_STATUS_MAPPING[maritalStatus] || 'Single';
};

export const getMaritalClassForTraditionalLTC = (
  paymentOption: string,
  selectedBuyerOption: BuyerOption,
  hasPartnerWithDemographics: boolean,
  clientMaritalStatus?: string,
): string => {
  const mappedMaritalStatus = mapMaritalStatusToTraditionalLTC(clientMaritalStatus);
  if (['Monthly', 'Annually'].includes(paymentOption)) {
    if (mappedMaritalStatus === 'Married' || hasPartnerWithDemographics) {
      return selectedBuyerOption.maritalClass;
    } else {
      return 'Single';
    }
  } else {
    return mappedMaritalStatus;
  }
};
